module.exports = __webpack_public_path__ + "static/media/crm_temp_revenue.47fee330.svg";